module.exports = "https://cdn.littlereply.com/tt/resource/full_duigou_18@3x.c914b938d41c195a2db9136fd6433f81.png";